import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/th/about")({
  head: () => pageHead("/about", "th"),
  component: About,
});
